/**
 * 2022-09-01
 * 个性设置-与模板相关
 */
const EMPTY_LIST = []

export default {
  data () {
    return {
      templateKeyMixins: '',
      templateListMixins: [],
      isEditTemplateName: false,
      modelMixins: {
        templateId: '',
        templateName: '',
        templateIndex: -1,
        templateList: []
      },
      dragOptionsMixins: {
        draggable: '.tpl',
        handle: '.tpl',
        animation: 150,
        filter: '.undraggable'
      }
    }
  },
  methods: {
    createTemplateMixins () {
      this.resetTemplateMixins()
      const tasks = this.getTasks('template')
      if (tasks) {
        this.showNameDialog()
      }
    },
    async saveTemplateMixins () {
      const tasks = this.getTasks('template')
      if (!tasks) {
        return
      }
      let url = this.isEditTemplateName ? 'system.defineSearchFieldTemplate.updateFieldTemplate' : 'system.defineSearchFieldTemplate.batchSaveOrUpdate'
      const list = tasks.map(v => {
        const genericId = v.genericId
        const obj = {
          templateName: this.modelMixins.templateName,
          genericId,
          fieldContent: v.fieldContent,
          fieldSnapshot: v.fieldSnapshot
        }
        const findItem = this.modelMixins.templateList.find(item => item.genericId === genericId)
        if (findItem && findItem.id) {
          obj.id = findItem.id
          obj.batchId = findItem.batchId
        }
        return obj
      })
      const obj = { batchId: this.modelMixins.templateId, templateName: this.modelMixins.templateName }
      await this.$http(url, this.isEditTemplateName ? obj : list)
      this.resetTemplateMixins()
      this.getTemplateListMixins()
      this.$message.success('保存模板成功')
    },
    async getTemplateListMixins () {
      this.templateListMixins = await this.$http('system.defineSearchFieldTemplate.list', { genericIds: [...this.getColumnsIds(), this.getFormId(), this.getGenericId()] })
    },
    // 自定义列
    getColumnsIds () {
      return this.tables.map(tab => this.option[tab.searchCode])
    },
    // 自定义查询
    getFormId () {
      let id = ''
      if (this.formFields && this.formFields.$columns) {
        const code = this.option.searchCode
        id = this.option[code]
      }
      return id
    },
    // 通用查询
    getGenericId () {
      let id = ''
      if (this.generic && this.generic.configColumns) {
        const code = this.generic.searchCode
        id = this.option[code]
      }
      return id
    },
    loadTemplateMixins (index) {
      let template = this.templateListMixins[index]
      this.modelMixins.templateIndex = index
      this.modelMixins.templateId = template.batchId
      this.modelMixins.templateName = template.templateName
      this.modelMixins.templateList = template.fieldTemplates
      this.setCheckMixins(template.fieldTemplates)
    },
    // 设置模板状态（自定义查询、通用查询、自定义列）
    // 设置模板时会对数据进行排序处理，会将被勾选的排序再前面
    setCheckMixins (templateList = []) {
      // 自定义查询
      const formId = this.getFormId()
      if (formId) {
        const obj = templateList.find(v => v.genericId === formId)
        if (obj) {
          const userKeys = obj ? JSON.parse(obj.fieldContent || '[]') : []
          let length = userKeys.length
          this.formFields.$columns.forEach(item => {
            const index = userKeys.indexOf(item.propertyName) + 1
            item.$show = index > 0
            item.index = index || ++length
          })

          // 个性设置分组的自定义查询不排序（全局成本等查询分组不排序）
          if (!this.option.group) {
            this.formFields.$columns.sort((a, b) => a.index - b.index)
          }
        } else {
          console.error('当前模版快捷查询配置和页面快捷查询配置不匹配')
        }
      }

      // 通用查询
      const genericId = this.getGenericId()
      if (genericId && this.generic.showGenericConfig) {
        const obj = templateList.find(v => v.genericId === genericId)
        if (obj) {
          const userKeys = obj ? JSON.parse(obj.fieldContent || '[]') : []
          let length = userKeys.length
          this.generic.configColumns.forEach(item => {
            const index = userKeys.indexOf(item.propertyName) + 1
            item.$show = index > 0
            item.index = index || ++length
          })
          this.generic.configColumns.sort((a, b) => a.index - b.index)
        } else {
          console.error('当前模版通用查询配置和页面通用查询不匹配')
        }
      }

      // 自定义列
      const columnsIds = this.getColumnsIds()
      if (columnsIds && columnsIds.length) {
        this.tables.forEach((tab, index) => {
          const obj = templateList.find(v => v.genericId === columnsIds[index])
          if (!obj) return console.error('当前模版列配置和实际表格列不匹配')
          const userKeys = obj ? JSON.parse(obj.fieldContent || '[]') : []
          // 所有模版保存字段
          let keys = []
          let childKeys = {}
          keys = userKeys.map(item => {
            if (typeof item === 'string') return item
            if (item.child && item.child.length) childKeys[item.key] = item.child
            return item.key || ''
          })
          // userKeys.forEach(item => {
          //   if (typeof item === 'string') {
          //     keys.push(item)
          //     return
          //   }
          //   if (item.child && item.child.length) {
          //     item.child.forEach(key => keys.push(key))
          //     return
          //   }
          //   keys.push(item.key)
          // })
          const snapshotObj = JSON.parse(obj.fieldSnapshot || '{}')
          const enableCollapse = this.getControlCollapseCol(tab)
          let length = keys.length
          tab.$columns.forEach(v => {
            const snapshotItem = snapshotObj && snapshotObj[v.key]
            const index = keys.indexOf(v.key) + 1
            v.$show = index > 0
            v.index = index || ++length

            if (enableCollapse) {
              const hasCollapseKeys = v.collapseKeys && v.collapseKeys.length > 0
              const isExpand = snapshotItem && snapshotItem.collapsed !== undefined ? !snapshotItem.collapsed : undefined
              v.$showExpand = !!hasCollapseKeys
              v.$isExpand = isExpand !== undefined ? !!isExpand : !!(!v.collapsed && hasCollapseKeys)
            }

            let childLength = childKeys[v.key] ? childKeys[v.key].length : 0
            if (v.children && v.children.length) {
              v.children.forEach(item => {
                const childIndex = childKeys[v.key] && childKeys[v.key].indexOf(item.key) + 1
                item.$show = childIndex > 0
                item.index = childIndex || ++childLength

                const snapshotChild = snapshotItem && snapshotItem.children
                const snapshotChildItem = snapshotChild && snapshotChild[item.key]
                if (enableCollapse) {
                  const hasChildCollapseKeys = item.collapseKeys && item.collapseKeys.length > 0
                  const isChildExpand = snapshotChildItem && snapshotChildItem.collapsed !== undefined ? !snapshotChildItem.collapsed : undefined
                  item.$showExpand = !!hasChildCollapseKeys
                  item.$isExpand = isChildExpand !== undefined ? !!isChildExpand : !!(!item.collapsed && hasChildCollapseKeys)
                }
              })
              // 设置一级头
              v.$show = v.children.every(item => item.$show)
              if (!v.$show && tab && tab.option && tab.option.draggableChild) {
                v.indeterminate = v.children.some(item => item.$show)
              }
              v.children.sort((a, b) => a.index - b.index)
            }
          })
          tab.$columns.sort((a, b) => a.index - b.index)
          this.handleCheck(tab.$columns, index, tab)
        })
      }
    },
    updateTemplateMixins (index) {
      let template = this.templateListMixins[index]
      this.modelMixins.templateIndex = index
      this.modelMixins.templateId = template.batchId
      this.modelMixins.templateName = template.templateName
      this.modelMixins.templateList = template.fieldTemplates
      this.isEditTemplateName = true
      this.showNameDialog()
    },
    async removeTemplateMixins (index) {
      await this.$confirm('是否删除该模板？', '提示')
      await this.$http('system.defineSearchFieldTemplate.delete', { batchId: this.templateListMixins[index].batchId })
      this.templateListMixins.splice(index, 1)
      this.resetTemplateMixins()
      this.$message.success('删除成功')
    },
    filterTemplateMixins (val, cb) {
      if (!this.templateListMixins.length || !val || val.length < 2) {
        cb(EMPTY_LIST)
        return
      }
      let arr = this.templateListMixins.filter(v => v.templateName && v.templateName.includes(val))
      cb(arr)
      // 自动选择第一行
      this.$nextTick(_ => {
        arr.length && this.$refs['templateFilter'].highlight && this.$refs['templateFilter'].highlight(0)
      })
    },
    selectTemplateMixins (val) {
      if (val) {
        let index = this.templateListMixins.findIndex(v => val.batchId === v.batchId)
        this.loadTemplateMixins(index)
        this.templateKeyMixins = ''
      }
    },
    resetTemplateMixins () {
      this.modelMixins.templateId = ''
      this.modelMixins.templateName = ''
      this.modelMixins.templateIndex = -1
      this.modelMixins.templateList = []
      this.isEditTemplateName = false
    },
    showNameDialog (val = true) {
      if (this.$refs.nameDialog) {
        this.$refs.nameDialog.show = val
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/module/columns-template.js